/*
 * Copyright '2022' Dell Inc. or its subsidiaries. All Rights Reserved.
 */

import { ITenantCustomBootstrapCode } from "sirius-shell-support-library/tenants/custom-code/tenant-custom-bootstrap-code.interface";
import { TenantCustomBootstrapCode } from "./custom-code/tenant-custom-bootstrap-code";
import { applyRuntimeConfig } from "sirius-platform-support-library/shared/environment/apply-runtime-config";
import { environment } from "./environments/environments";
import { runtimeEnvironments } from "./environments/runtime-environments";
import { EnvironmentType } from "sirius-platform-support-library/tenants/tenant-context";
import { FeedbackWebElement } from "./custom-code/core/feedback/components/feedback.web-element";

const getCustomBootstrapCode = function (): ITenantCustomBootstrapCode {
  // Moved this from body of main.js to here to mitigate the issue that can be caused while preloading the custom code bundle
  applyRuntimeConfig(environment, runtimeEnvironments, EnvironmentType.TENANT);

  FeedbackWebElement.register();

  return new TenantCustomBootstrapCode();
};

export { TenantCustomBootstrapCode, getCustomBootstrapCode };
